<div mdcCard class="cf2-alt-expansion-panel custom-card">
  @if (displayHeader && disableExpansion === false && displayTitleText() === false) {
    <mat-toolbar mdcRipple (click)="toggle()">
      <div class="toolbar-fields">
        <button mat-icon-button>
        <span class="title-span">
          @if (isCollapsable) {
            <mat-icon>{{ !isExpanded ? 'add' : 'remove' }}</mat-icon>
          }
          &nbsp;<ng-content select="panel-title"></ng-content>
        </span>
        </button>
      </div>
    </mat-toolbar>
  }

  @if (displayHeader && disableExpansion === false && displayTitleText()) {
    <mat-toolbar mdcRipple (click)="toggle()">
      <div class="toolbar-fields">
        <button mat-icon-button>
          <span class="title-span">
            @if (isCollapsable) {
              <mat-icon>{{ !isExpanded ? 'add' : 'remove' }}</mat-icon>
            }              
            {{ titleText }}
          </span>
        </button>
        <span class="spacer"></span>
        <span class="subtitle">{{ centreText }}</span>
        <span class="spacer"></span>
        <span class="subtitle">{{ subTitleText }}</span>
      </div>
    </mat-toolbar>
  }

  @if (displayHeader && disableExpansion) {
    <mat-toolbar class="no-expansion">
      <div class="toolbar-fields">
        {{ titleText }}
        <span class="spacer"></span>
        <span class="subtitle">{{ subTitleText }}</span>
      </div>
    </mat-toolbar>
  }

  @if (isExpanded) {
    <ng-container>
      <div class="card-content">
        <ng-content select="panel-content"></ng-content>
      </div>
    </ng-container>
  }
</div>